import React, {useEffect, useRef, useState, useContext} from 'react';
import ChartLine from "./icons/chartLine";
import ChartBar from "./icons/chartBar";
import Chart from "./chart";
import handleRowLineBtn from "../utilities/handleRowLineBtn";
import handleRowColumnBtn from "../utilities/handleRowColumnBtn";
import formatNumber from "../utilities/formatNumber";
import TableNav from "./tableNav";
import {SheetContext} from "./sheetContext";
import { v4 as uuidv4 } from 'uuid';
import {includes} from "lodash";

const Table = () => {
  const {chartData, tableData, parsedShowCells, tabletoolContainer, activeSheet} = useContext(SheetContext)
  const chartComponent = useRef(null);
  const [chart, setChart] = useState();

  const firstActiveItem = () => {
    const activeItemArray = [];
    tableData.rows && Object.values(tableData.rows).forEach((data, index) => {
      if (data.chartable) {
        activeItemArray.push(index)
      }
    })
    return activeItemArray[0]
  }

  useEffect(() => {
    setChart(chartComponent.current.chart)
  }, [chart])

  useEffect(() => {
    chart && chart.series[firstActiveItem()].update({
      type: 'column',
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSheet])

  return (
    <>
      <Chart data={chartData} chartComponent={chartComponent}/>
      {tabletoolContainer && parsedShowCells && <TableNav/>}
      <table className="table">
        <tbody>
        {tabletoolContainer && tableData.rows && Object.values(tableData.rows).map((row, index) => (
          <tr className={`${!row.chartable ? 'not-chartable': ''}`} key={index}>
            <td className={`tt-col ${index === firstActiveItem() ? 'active' : ''} ${row.footnote ? 'fw-normal small' : ''} ${row?.styles?.bold ? 'fw-bold' : '' } ${row?.styles?.italic ? 'fst-italic' : '' } description position-relative`} colSpan={row.full_row ? Object.values(row.data).length : null}>
              <span key={uuidv4()} className={`${!row.chartable ? 'd-none' : ''} table-icons position-absolute`}>
                <button className={` border-0 btn-line`} onClick={(e) => handleRowLineBtn(e, index, chart, tabletoolContainer)}><ChartLine/></button>
                <button className={`${index === firstActiveItem() ? 'active' : ''} btn-column border-0`} onClick={(e) => handleRowColumnBtn(e, index, chart, tabletoolContainer)}><ChartBar/></button>
              </span>
              <span key={uuidv4()} className="text" style={{borderBottomColor: `${chartData.series && index === firstActiveItem() ? chartData.series[firstActiveItem()].color : ''}`}}>{row.row_title}</span>
            </td>
            {!row.full_row && Object.entries(row.data).map((column, index) => {
              return index > 0 ? <td className={`tt-col-${index} position-relative ${index > parsedShowCells ? 'd-none': '' } ${row?.styles?.bold ? 'fw-bold' : '' } ${row?.styles?.italic ? 'fst-italic' : '' }`} key={index}>{row.chartable && parseFloat(column[1]) ? formatNumber(column[1], row.decimals): column[1]}{row.chartable && parseFloat(column[1]) && includes(tableData.chartable_columns, column[0]) ? row?.suffix : '' }<span className="bar"/></td> : null
            }
            )}
          </tr>
        ))}
        </tbody>
      </table>
    </>
  );
};

export default Table;

